import { useEffect, useState } from "react";

import { HistoryItem, UUID } from "../../../types/common";
import {
    PaymentOrderStatus,
    PreSubmitHistory,
} from "../../../types/payment";

type FetchState = {
    data: Map<UUID, HistoryItem<PaymentOrderStatus>[]>;
    isLoading: boolean;
};


const usePreSubmitItemHistory = (
    ids: UUID[],
    fetcher: (id: string) => Promise<PreSubmitHistory>,
): FetchState => {
    const [isLoading, setLoading] = useState(false);
    const [result, setResult] = useState<Map<UUID, HistoryItem<PaymentOrderStatus>[]>>(new Map());

    useEffect(() => {
        let isCancelled = false;

        const fetch = async () => {
            setLoading(true);
            try {
                const res = await Promise.all(
                    ids.map(async (id) => await fetcher(id)),
                );

                if (!isCancelled) {
                    setResult(
                        new Map(
                            res.map((history, index) => [
                                ids[index],
                                history.statusHistory ?? [],
                            ]),
                        ),
                    );
                    setLoading(false);
                }
            } catch (e) {
                if (!isCancelled) {
                    setResult(new Map());
                    setLoading(false);
                }
            }
        };
        fetch();

        return () => {
            isCancelled = true;
        };
    }, [fetcher, ids]);

    return {
        data: result,
        isLoading,
    };
};

export default usePreSubmitItemHistory;
